export default () => ({
    user: {
        name: '',
        phone: null
    }
})